import { render, staticRenderFns } from "./MyEarnings.vue?vue&type=template&id=22af4a28&scoped=true"
import script from "./MyEarnings.vue?vue&type=script&lang=js"
export * from "./MyEarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af4a28",
  null
  
)

export default component.exports